import { useState } from "react";
import { Monitor, Smartphone } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../../ui/dialog";

export const SeoPagePreviewDialog = ({ open, onOpenChange, slug }) => {
  const [viewMode, setViewMode] = useState("desktop");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="seo-preview-dialog"
        className="max-w-none w-screen h-screen top-0 left-0 translate-x-0 translate-y-0 p-0 m-0 rounded-none border-none bg-[#0a0a0a] overflow-hidden flex flex-col gap-0"
      >
        <DialogTitle className="sr-only">Vista previa de la página {slug}</DialogTitle>
        <DialogDescription className="sr-only">Vista previa sin guardar del contenido de la página {slug}</DialogDescription>

        <div
          data-testid="seo-preview-banner"
          className="shrink-0 flex items-center justify-between gap-4 flex-wrap bg-twp-gold text-black text-xs uppercase tracking-[0.2em] font-semibold px-5 py-3"
        >
          <span>Vista previa (cambios sin guardar) — URL: {slug}</span>
          <div className="flex items-center gap-1 bg-black/10 rounded-full p-1">
            <button
              type="button"
              data-testid="seo-preview-desktop-toggle"
              onClick={() => setViewMode("desktop")}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] transition-colors ${
                viewMode === "desktop" ? "bg-black text-white" : "text-black/70 hover:bg-black/10"
              }`}
            >
              <Monitor size={13} /> Escritorio
            </button>
            <button
              type="button"
              data-testid="seo-preview-mobile-toggle"
              onClick={() => setViewMode("mobile")}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] transition-colors ${
                viewMode === "mobile" ? "bg-black text-white" : "text-black/70 hover:bg-black/10"
              }`}
            >
              <Smartphone size={13} /> Móvil
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-auto flex items-center justify-center py-6">
          {open && (
            <iframe
              key={viewMode}
              data-testid="seo-preview-iframe"
              src={`${window.location.origin}/admin/preview/seo-page`}
              title="Vista previa de la página SEO"
              className={
                viewMode === "mobile"
                  ? "w-[390px] h-[780px] border-4 border-white/15 rounded-[2.25rem] shadow-2xl bg-black"
                  : "w-full h-full border-none bg-black"
              }
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
